import searchBarClose from './searchBarClose';
import { ProductCard } from './card/index';
import Cookie from '../../components/cookies';

const $ = require('jquery');

window.jQuery = $;
window.$ = $;

const category = () => {
  // internal functions call from here...

  readMore();
  paginateSlider();
  searchBarClose();
  handleView();
  handleBackToTop();

  const productcard = new ProductCard($('.variant-selector'));
  productcard.init();

  /** Load more button effect on mobile */
  $('#js-load-more').on('touchend', function () {
    addhoverEffect();
  });
  /** Load more button function */
  $(document).on('click', '.js-load-more', function () {
    const $this = $(this);
    const totalPages = parseInt($('[data-all-pages]').val());
    const currentPage = parseInt($('[data-this-page]').val());
    $this.attr('disabled', true);
    $this.find('[loader]').removeClass('hide');
    const nextUrl = $('[data-next-link]').val();
    const current_page_new = currentPage + 1;
    const next_coll = currentPage + 2;
    $.ajax({
      url: nextUrl,
      type: 'GET',
      dataType: 'html',
      success(responseHTML) {
        const colUrl = $('[data-next-link]')
          .val()
          .replace(`page=${current_page_new}`, `page=${next_coll}`);
        $('[data-next-link]').val(colUrl);
        $('[data-this-page]').val(current_page_new);
        setGrid(responseHTML);
      },
      complete() {
        if (current_page_new < totalPages) {
          $this.attr('disabled', false);
          $this.find('[load-more-text]').removeClass('hide');
          $this.find('[loader]').addClass('hide');
        }
        if (current_page_new >= totalPages) {
          $this.find('[load-more-text]').attr('disabled', true);
          $this.find('[loader]').addClass('hide');
        }
        // product count
        const collectionSize = parseInt($('[data-coll-page-size]:last').val());
        const counter =
          parseInt($('.current__products').text()) + collectionSize;
        $('.current__products').text(counter);
        // paginate slider
        $('.flex ul li').removeClass('is-selected last-selected');
        const sliderNum = $('.flex ul').find(
          `[data-index='${current_page_new}']`,
        );
        $(sliderNum).addClass('last-selected');
        $('.flex ul li')
          .slice(0, current_page_new)
          .each(function () {
            $(this).addClass('is-selected');
          });
        // activate quick add mobile and add to cart after loading more
        productcard.init();
      },
    });
  });
};

/* pagination slider */
const paginateSlider = () => {
  $('.flex ul li:first').addClass('is-selected last-selected');
};

/* plp description */
const readMore = () => {
  let maxLengthDesk = 545;
  const width = window.innerWidth;
  if (width <= 990) {
    maxLengthDesk = 200;
  }
  readMoreReset();
  $('.collection-hero__description span').each(function () {
    const myStr = $(this).html();
    if ($.trim(myStr).length > maxLengthDesk) {
      const newStr = myStr.substring(0, maxLengthDesk);
      const removedStr = myStr.substring(maxLengthDesk, $.trim(myStr).length);
      $(this).empty().html(newStr);
      $(this).append('<span class="elip">...</span>');
      $(this).append(
        `<span class="more-text" style="display: none;">${removedStr}</span>`,
      );
      $(this).append(
        '<a href="javascript:void(0);" class="read-more" data-val="read-more"> <span class="read-more-text"> Read More </span> <span class="read-more-plus"> + </span> </a>',
      );
    }
  });
  $('.read-more').on('click', function () {
    const readValue = $(this).attr('data-val');
    if (readValue == 'read-more') {
      readMoreReset(readValue);
    } else {
      readMore();
    }
  });
};
const readMoreReset = (data) => {
  $('span.elip').remove();
  $('.read-more').siblings('.more-text').contents().unwrap();
  $('.read-more').slice(1).remove();
  if (data && data == 'read-more') {
    $('.read-more').attr('data-val', 'read-less');
    $('.read-more-text').text('Read Less');
    $('.read-more-plus').text('-');
  }
};
/* end plp description */

const addhoverEffect = () => {
  $('#js-load-more').addClass('load-more-white');
  setTimeout(() => {
    $('#js-load-more').removeClass('load-more-white');
  }, '500');
};

const setGrid = (responseHTML) => {
  const width = window.innerWidth;
  const $container = $(responseHTML).find('.product-grid');
  // $container.find('.collection__product-grid__bannerXsearch-wrapper').remove();
  // append li before collection banner
  if ($('.current__products').text() <= 16) {
    if (
      (width > 990 && $('#changeGridView').attr('data-value') == 2) ||
      $('#changeGridView').attr('data-value') == 1
    ) {
      const firstList = $container.find('li:first-child').clone();
      $(firstList).insertBefore(
        '.collection__product-grid__bannerXsearch-wrapper',
      );
      $container.find('li:first-child').remove();
    }
  }
  $('.product-grid').append($container.html());
};

const VIEW_TYPE_COOKIE = 'product-view-type';

const handleView = () => {
  const cookie = new Cookie();
  const viewSwitch_container = $('#ProductSwitchContainer');
  const viewSwitch_options = viewSwitch_container.find('li');
  const list_container = $('#ProductGridContainer');

  const applyView = (view_type) => {
    viewSwitch_options.removeClass('active');
    viewSwitch_options
      .filter(`[data-view-type="${view_type}"]`)
      .addClass('active');
    list_container.attr('data-view-type', view_type);
  };

  // restore the view the customer last picked (survives refresh, pagination
  // and the full page reload facets.js triggers on filter change)
  const savedView = cookie.getCookie(VIEW_TYPE_COOKIE);
  if (savedView) {
    applyView(savedView);
  }

  viewSwitch_options.on('click', function () {
    const view_type = $(this).attr('data-view-type');
    applyView(view_type);
    cookie.setCookie(VIEW_TYPE_COOKIE, view_type, 'no-expiry');
  });
};

const handleBackToTop = () => {
  const $backToTop = $('#backToTop');

  if ($backToTop) {
    $(window).on('scroll', function () {
      if ($(this).scrollTop() > $(window).height()) {
        $backToTop.fadeIn();
      } else {
        $backToTop.fadeOut();
      }
    });

    $backToTop.on('click', function () {
      $('html, body').animate({ scrollTop: 0 }, 'smooth');
    });
  }
};

export default category;
